import React from "react";
import PropTypes from "prop-types";
import { useTable } from "react-table";
import { ErrorBoundary } from ".";

import "./ResponsiveTable.scss";

function ResponsiveTable({columns, title="data", data, onClickRow, loading=false}) {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({ columns, data });

  const rowClickHandler = React.useCallback(
    (row) => {
      onClickRow && onClickRow(row)
    },
    [onClickRow]
  );

  if (loading)
    return <div className='d-flex justify-content-center align-items-center p-3'>Loading...</div>

  if (rows.length < 1 )
    return <div className='d-flex justify-content-center align-items-center p-3'>No {title} available</div>

  return (
    <ErrorBoundary>
      <div className="table-responsive">
      <table
          {...getTableProps()}
          className={`table table-borderless table-hover ${
            onClickRow ? "table-row-clickable" : ""
          }`}
        >
          <thead>
            {headerGroups.map(headerGroup => (
              <tr {...headerGroup.getHeaderGroupProps()} className="header-row">
                {headerGroup.headers.map(column => (
                  <th {...column.getHeaderProps()} scope="col">
                    {column.render('Header')}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody {...getTableBodyProps()}>
            {rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} onClick={() => rowClickHandler(row)} className="data-row">
                  {row.cells.map(cell => {
                    return (
                      <td {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </ErrorBoundary>
  );
}

ResponsiveTable.defaultProps = {};

ResponsiveTable.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  onClickRow: PropTypes.func
};

export default ResponsiveTable;